export default class HttpClient {
  constructor(baseURL, authErrorEventBus, getCsrfToken) {
    this.baseURL = baseURL;
    this.authErrorEventBus = authErrorEventBus;
    this.getCsrfToken = getCsrfToken;
  }
  async fetch(url, options) {
    const res = await fetch(`${this.baseURL}${url}`, {
      ...options,
      headers: {
        "Content-Type": "application/json", //
        ...options.headers,
        "dwitter-csrf-token": this.getCsrfToken(), // fetch할때마다 헤더에 custom header 추가해서 서버에 보냄
      },
      credentials: "include", // 브라우저가 자동으로 credential에 있는것 추가함 (cookie 읽어옴)
    });

    // --- <<Parsing>> ---
    // if there's body, body(json) will be converted to Js object
    let data;
    try {
      data = await res.json();
    } catch (error) {
      // res.body 없는 경우 에러 발생할 수 있음
      console.error(error);
    }

    /*
        응답으로 온 json데이터(텍스트) -> JS 객체로 변환
        시간 많이 걸리는 작업이라 비동기 -> await 필요

        서버의 res.json(객체): JS객체를 글자(JSON)로 만들어서 보냄. (Stringify)
        브라우저의 res.json(): 받은 글자(JSON)를 다시 JS객체로 만듦. (Parse)

        JSON은 그냥 '글자(String)'이고, 우리가 코드에서 점(.) 찍고 쓰려면 '자바스크립트 객체'여야 함
        json(): 응답 객체의 메서드(기능)
        JSON: JS내의 전역 객체

        JSON 객체가 가지고 있는 메서드들(기능) -> 데이터 변환 용도로 사용
        JSON.parse(...): json(텍스트) -> 객체 변환
        JSON.stringify(...): 객체 -> json(텍스트) 변환
    */

    if (res.status > 299 || res.status < 200) {
      const message =
        data && data.message ? data.message : "Something went wrong!";
      const error = new Error(message);
      if (res.status === 401) {
        // 401: unauthorized error
        this.authErrorEventBus.notify(error);
        return;
      }
      throw error; // ??
    }
    return data;
  }
}
